(ns hypnos.dme.panel.error
  "Error panel for the DME application."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The error panel/modal"
  []
  (let [error (rf/subscribe [:dme/error])]
    [:div#error.modal {:class (when (:type @error) "is-active")}
     [:div.modal-background
      {:on-click (fn [_] (rf/dispatch [:dme/clear-error]))}]
     [:div.modal-card
      [:header.modal-card-head
       [:p.modal-card-title "Error"]
       [:button.delete
        {:aria-label "close"
         :on-click (fn [_] (rf/dispatch [:dme/clear-error]))}]]
      [:section.modal-card-body
       [:div.content
        [:h3 (:message @error)]
        [:p "Please check your input and try again."]]]
      [:footer.modal-card-foot
       [:a.button
        {:href     "/"
         :on-click (fn [_] (rf/dispatch [:dme/clear-error]))}
        "Close"]]]]))
